import { render, staticRenderFns } from "./LimitPage.vue?vue&type=template&id=088e2341&scoped=true&"
import script from "./LimitPage.vue?vue&type=script&lang=js&"
export * from "./LimitPage.vue?vue&type=script&lang=js&"
import style0 from "./LimitPage.vue?vue&type=style&index=0&id=088e2341&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e2341",
  null
  
)

export default component.exports